<div class="dp-conatiner">
    <div class="mat-close-btn">
        <mat-icon (click)="closeDialog()" class="close-icon">close</mat-icon>
    </div>
    <div class="input-group">
        <label>Start date *</label>
        <input [(ngModel)]="startDate" type="date" class="dp-input-control input-div" placeholder="dd/mm/yyyy" [max]="today" required>
        <label class="end-date"> End Date *</label>
        <input [(ngModel)]="endDate" type="date" class="dp-input-control input-div" placeholder="dd/mm/yyyy" [max]="today" required>
    </div>
    <div class="d-flex btn-main-div">
        <button class="dp-secondary-btn btn-div" (click)="clearData()">
            Clear all
        </button>

        <button class="dp-primary-btn btn-div" (click)="searchForData()">
            Search
        </button>
    </div>
</div>